export const GET_DATEPICKER_TRANSLATION = "GET_DATEPICKER_TRANSLATION";
export const SET_DATEPICKER_TRANSLATION = "SET_DATEPICKER_TRANSLATION";

export const GET_PROJECT_DETAILS = "GET_PROJECT_DETAILS";
export const SET_PROJECT_DETAILS = "SET_PROJECT_DETAILS";

export const GET_SCHEMA = "GET_SCHEMA";
export const SET_SCHEMA = "SET_SCHEMA";

export const GET_JOB_PHASE = "GET_JOB_PHASE";
export const SET_JOB_PHASE = "SET_JOB_PHASE";
export const GET_JOB_DETAILS = "GET_JOB_DETAILS";
export const SET_JOB_DETAILS = "SET_JOB_DETAILS";

export const SET_PHASE_DETAILS = "SET_PHASE_DETAILS";

export const SET_SELECTED_FILES = "SET_SELECTED_FILES";
export const REMOVE_SELECTED_FILE = "REMOVE_SELECTED_FILE";
export const SET_FINISHED_UPLOADS = "SET_FINISHED_UPLOADS";
export const REMOVE_SELECTED_FILES = "REMOVE_SELECTED_FILES";

export const COMPLETE_INTAKE = "COMPLETE_INTAKE";

export const SET_SCHEMA_ELEMENT_VALUE = "SET_SCHEMA_ELEMENT_VALUE";
export const SET_SCHEMA_ELEMENT_ERRORS = "SET_SCHEMA_ELEMENT_ERRORS";

export const SET_JOB_MASK_DATA = "SET_JOB_MASK_DATA";
export const INCREMENT_UPLOADED_FILES = "INCREMENT_UPLOADED_FILES";
export const ADD_FAILED_FILE_UPLOAD_PATH = "ADD_FAILED_FILE_UPLOAD";
export const REMOVE_FAILED_FILE_UPLOAD_PATH = "REMOVE_FAILED_FILE_UPLOAD";
export const UPDATE_FAILED_UPLOAD_DIALOG = "UPDATE_FAILED_UPLOAD_DIALOG";
export const ADD_UPLOADED_CHUNK = "ADD_UPLOADED_CHUNK";
export const CREATE_UPLOADED_CHUNKS_HOLDER = "CREATE_UPLOADED_CHUNKS_HOLDER";
export const RETRIEVE_ELEMENTS_VALUES = "RETRIEVE_ELEMENTS_VALUES";

export const GET_WORKFLOW_DEFINITIONS = "GET_WORKFLOW_DEFINITIONS";
export const SET_WORKFLOW_DEFINITIONS = "SET_WORKFLOW_DEFINITIONS";

export const GET_ENABLE_BULK_COMPLETE = "GET_ENABLE_BULK_COMPLETE";
export const SET_ENABLE_BULK_COMPLETE = "SET_ENABLE_BULK_COMPLETE";

export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
export const SET_CONTENT_TYPE = "SET_CONTENT_TYPE";
export const SET_FILE_SELECTION_TYPE = "SET_FILE_SELECTION_TYPE";
export const SET_DISPLAY_TYPE = "SET_DISPLAY_TYPE";

export const SET_NAVIGATION_ELEMENTS = "SET_NAVIGATION_ELEMENTS";
export const SET_NAVIGATION_SELECTION = "SET_NAVIGATION_SELECTION";
export const SET_SIGNED_RESOURCES_MAP = "SET_SIGNED_RESOURCES_MAP";
export const RENEW_SIGNED_MEDIA_URL = "RENEW_SIGNED_MEDIA_URL";
export const SHOW_UPLOAD_OVERLAY = "SHOW_UPLOAD_OVERLAY";
export const SHOW_RESET_TASK_DIALOG = "SHOW_RESET_TASK_DIALOG";
export const SET_JOB_SECTION_INSTRUCTIONS_VISIBLE = "SET_JOB_SECTION_INSTRUCTIONS_VISIBLE";
export const SET_BULK_CONFIRMATION_DIALOG_ACTION = "SET_BULK_CONFIRMATION_DIALOG_ACTION";
export const SET_JOB_SECTION_STATUS_STATS_VISIBLE = "SET_JOB_SECTION_STATUS_STATS_VISIBLE";
export const SET_USER_MENU_OPEN_KEYS = "SET_USER_MENU_OPEN_KEYS";
export const SET_USER_MENU_VISIBLE = "SET_USER_MENU_VISIBLE";

export const SAVE_BATCH_FIELDS_DATA = "SAVE_BATCH_FIELDS_DATA";

export const GET_TASK_LIST = "GET_TASK_LIST";
export const SET_TASK_LIST = "SET_TASK_LIST";
export const SET_ACTIVE_TASK_BY_ID = "SET_ACTIVE_TASK_BY_ID";
export const CHANGE_ACTIVE_TASK = "CHANGE_ACTIVE_TASK";
export const UPDATE_ACTIVE_TASK_PRIVATES = "UPDATE_ACTIVE_TASK_PRIVATES";
export const GET_ACTIVE_TASK_DETAILS = "GET_ACTIVE_TASK_DETAILS";
export const SAVE_ACTIVE_TASK = "SAVE_ACTIVE_TASK";
export const UPDATE_ACTIVE_TASK = "UPDATE_ACTIVE_TASK";
export const UPDATE_TASK_ENTITY_BY_ID = "UPDATE_TASK_ENTITY_BY_ID";
export const SAVE_TASK_SUCCESS = "SAVE_TASK_SUCCESS";
export const SAVE_COMPLETED = "SAVE_COMPLETED";
export const START_TASK_WIZARD = "START_TASK_WIZARD";
export const SET_TASK_MASK_DATA = "SET_TASK_MASK_DATA";
export const RESET_TASK_DATA = "RESET_TASK_DATA";
export const SELECT_TASK_IN_WIZARD = "SELECT_TASK_IN_WIZARD";
export const UPDATE_TASK_STATUS = "UPDATE_TASK_STATUS";

export const ADD_ALERTS = "ADD_ALERTS";
export const REMOVE_ALERT = "REMOVE_ALERT";
export const CLEAR_ALERTS = "CLEAR_ALERTS";

export const INIT_MANIFOLD = "INIT_MANIFOLD";
// file sign
export const SIGN_RESOURCE = "SIGN_RESOURCE";
export const SIGN_TASK_FILE = "SIGN_TASK_FILE";
export const SIGN_JOB_FILE = "SIGN_JOB_FILE";
export const SIGN_FILE_RESOURCE = "SIGN_FILE_RESOURCE";
export const PROCESS_PUBLIC_URL = "PROCESS_PUBLIC_URL";
export const PROCESS_RESOURCE_URL = "PROCESS_RESOURCE_URL";
export const LEGACY_SIGN_RESOURCE = "LEGACY_SIGN_RESOURCE";
